import { withChartLayout } from 'components/common';
import ActivitiesDailyLiving from 'components/features/chart/provider-chart/history-physical/activities-daily-living/ActivitiesDailyLiving';

const ActivitiesDailyLivingPage = withChartLayout('Activities of Daily Living')(ActivitiesDailyLiving);
export default ActivitiesDailyLivingPage;
